import { create } from "zustand";

interface Permission {
  code: string;
  name?: string;
}

interface PermissionState {
  permission: Permission[];
  setPermission: (list: Permission[]) => void;
  reset: () => void;
}

const initialState = { permission: [] as Permission[] };

export const usePermissionStore = create<PermissionState>((set) => ({
  ...initialState,
  setPermission: (list) => set({ permission: list }),
  reset: () => set(initialState),
}));
